"use client";
import { jsx as s, jsxs as r, Fragment as y } from "react/jsx-runtime";
import b from "clsx";
import x from "next/link";
import { memo as h } from "react";
import '../../assets/GetAppButton.css';const N = "_button_15ytj_1", f = "_icon_15ytj_15", v = "__disabled_15ytj_32", g = "__loading_15ytj_36", A = "_desc_15ytj_41", B = "_title_15ytj_50", G = "_text_15ytj_60", t = {
  button: N,
  icon: f,
  _disabled: v,
  _loading: g,
  desc: A,
  title: B,
  text: G
}, L = h(
  ({
    icon: m,
    title: u,
    text: j,
    loading: n,
    disabled: c,
    className: p,
    href: i,
    onClick: e,
    ...o
  }) => {
    const _ = (a) => {
      if (n || c) {
        a.preventDefault();
        return;
      }
      e == null || e(
        a
      );
    }, l = /* @__PURE__ */ r(y, { children: [
      /* @__PURE__ */ s("div", { className: t.icon, children: m }),
      /* @__PURE__ */ r("div", { className: t.desc, children: [
        /* @__PURE__ */ s("div", { className: t.title, children: u }),
        /* @__PURE__ */ s("div", { className: t.text, children: j })
      ] })
    ] }), d = b(
      t.button,
      {
        [t._loading]: n,
        [t._disabled]: c
      },
      p
    );
    return i ? /* @__PURE__ */ s(x, { href: i, onClick: _, className: d, ...o, children: l }) : /* @__PURE__ */ s("button", { onClick: _, className: d, ...o, children: l });
  }
);
L.displayName = "GetAppButton";
export {
  L as GetAppButton
};
